import { toast } from "react-toastify";
import RequisitionType from "Services/Requisition/RequisitionTypeService";

const hasPrinterContent = (content: any) => {
  if (content == null) return false;
  if (Array.isArray(content)) return content.length > 0;
  if (typeof content === "string") return content.trim().length > 0;
  return true;
};

const getApiErrorMessage = (error: any) =>
  error?.response?.data?.message ||
  error?.response?.data?.Message ||
  "Failed to get printer content";

export const getPrinterContentData = async (payload: any) => {
  try {
    const printerContent = await RequisitionType.getPrinterContent(payload);
    const content = printerContent?.data?.data;
    const apiMessage = printerContent?.data?.message;

    if (!hasPrinterContent(content)) {
      toast.error(apiMessage || "Printer setup or label content not found.");
      return null;
    }

    return content;
  } catch (error: any) {
    toast.error(getApiErrorMessage(error));
    return null;
  }
};
